import { h, ComponentChildren } from "preact";
import styles from "./style.module.scss";
interface Props {
    areaId: string;
    street: string;
    postCodeLabel: ComponentChildren;
    selected: boolean;
    count: number;
    isEditable: boolean;
    onToggle(checked: boolean): void;
}
const StreetSelectionRow = ({
    areaId,
    street,
    postCodeLabel,
    selected,
    count,
    isEditable,
    onToggle,
}: Props) => (
    <tr key={street}>
        {isEditable && (
            <td>
                <input
                    type="checkbox"
                    id={`selectGroup-${areaId}-${street}`}
                    name={`selectGroup-${areaId}-${street}`}
                    checked={selected}
                    onChange={(e) =>
                        onToggle((e.target as HTMLInputElement).checked)
                    }
                />
            </td>
        )}
        <td className={styles.zipcodeArea}>{postCodeLabel}</td>
        <td>{street}</td>
        <td>{count}</td>
    </tr>
);
export default StreetSelectionRow;
